import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import Banner from '../../styled/components/single-column-banner';

type Props = {
  buyComplete: boolean;
};

const ThankYouBanner = ({ buyComplete }: Props) => (
  <Banner className='flex-dir-col pad pad-top-lg pad-bottom-lg'>
    <SRow className='align-items-center'>
      <SCol span='12' center='' className='pad-bottom-none'>
        <h1 className='text-center text-xxl font-normal text-white'>
          {t('client.headings.thank-you-for-select-action-avatax', {
            action: buyComplete ? 'purchasing' : 'trying',
          })}
        </h1>
      </SCol>
    </SRow>
    <SRow className='justify-content-center'>
      <SCol span='8' center='' className='pad-bottom-none margin-top-sm'>
        <h2 className='text-center text-white'>
          {"We'll send you an email with a link to activate your new AvaTax account and set your password."}
        </h2>
      </SCol>
    </SRow>
  </Banner>
);

export default ThankYouBanner;
